<template>
    <div class="screenWidth itemList pt-4">
        <!-- 麵包屑 -->
        <BreadCrumbs :breadCrumbList="breadCrumbList"
                     :gaData="gaData" />
        <!-- menu -->
        <Categories class="py-3"
                    :gaData="gaData"
                    :active="category"
                    :loading="loading"
                    @getCategory="getCategory" />
        <!-- 切換顯示樣式 -->
        <div class="mb-3 mb-lg-0 pt-3 pt-md-0 row no-gutters">
            <div class="col-12">
                <Theme :titleText="'所有排行'"
                       :font24="true"
                       class="mb-3" />
            </div>
            <!-- select -->
            <!-- flex-column-reverse flex-md-row -->
            <div class="col-12 d-block d-md-flex justify-content-md-end">
                <Select class="d-md-flex justify-content-md-start"
                        :selectName="'排序依據：'"
                        :value="time.label"
                        :disabled="loading"
                        :selectOption="timeList"
                        @selectemit="setTime" />
                <Select class="d-md-flex justify-content-md-start"
                        :selectName="'觀看形式：'"
                        :value="count.label"
                        :disabled="loading"
                        :selectOption="countList"
                        @selectemit="setCount" />
                <Select class="d-md-flex justify-content-md-start"
                        :selectName="'媒體格式：'"
                        :value="type.label"
                        :disabled="loading"
                        :selectOption="typeList"
                        @selectemit="setType" />
                <!-- 切換顯示樣式 -->
                <div class="text-right listType mb-4 mt-lg-1">
                    <button type="button"
                            class="btn btn-link py-0 border-right rounded-0"
                            @click="setDisplay('card')">
                        <GridIcon v-if="display === 'card'"
                                  size="1.45x"
                                  stroke-width="2" />
                        <GridIcon v-else
                                  size="1.45x"
                                  stroke-width="1.25"
                                  class="lightcolor" />
                    </button>
                    <button type="button"
                            class="btn btn-link py-0 rounded-0"
                            @click="setDisplay('list')">
                        <AlignCenterIcon v-if="display === 'list'"
                                         size="1.45x"
                                         stroke-width="2" />
                        <AlignCenterIcon v-else
                                         size="1.45x"
                                         stroke-width="1.25"
                                         class="lightcolor" />
                    </button>
                </div>
            </div>
        </div>
        <!-- 文章資料 -->
        <ArticleDisplay :display="display"
                        :contentPage="contentPage"
                        :articleRes="articleRes"
                        :currentPage="currentPage"
                        :isShowOrderNum="true"
                        :loading="loading" />
        <Pagination :lastPage="lastPage"
                    :gaData="gaData"
                    :currentPage="currentPage"
                    @getPage="getPage" />
    </div>
</template>
<script>
import { post } from '@/api';
import { AlignCenterIcon, GridIcon } from 'vue-feather-icons';
import Theme from '@/components/Theme.vue';
import BreadCrumbs from '@/components/BreadCrumbs.vue';
import Categories from './Categories.vue';
import ArticleDisplay from './ArticleDisplay.vue';
import Select from './Select.vue';
import Pagination from '@/components/Pagination.vue';
import moment from 'moment';

export default {
    name: 'RankingArticleList',
    components: {
        Theme,
        AlignCenterIcon,
        GridIcon,
        Categories,
        ArticleDisplay,
        Select,
        Pagination,
        BreadCrumbs,
    },
    data() {
        return {
            loading: false,
            contentPage: '全站排行',
            category: '',
            total: 1098,
            currentPage: 1,
            lastPage: 0,
            breadCrumbList: [{ name: '全站排行', link: '', ga: '' }],
            time: {
                value: 'all',
                label: '全部',
            },
            count: {
                value: 'viewCounts',
                label: '瀏覽數',
            },
            type: {
                value: '',
                label: '全部',
            },
            menu: {},
            display: 'list',
            timeList: [
                {
                    value: 'all',
                    label: '全部',
                },
                {
                    value: 'w',
                    label: '週排行',
                },
                {
                    value: 'm',
                    label: '月排行',
                },
                {
                    value: 'y',
                    label: '年排行',
                },
            ],
            countList: [
                {
                    value: 'onDate',
                    label: '最新',
                },
                {
                    value: 'viewCounts',
                    label: '瀏覽數',
                },
                {
                    value: 'likeCounts',
                    label: '喜愛數',
                },
                {
                    value: 'shareCounts',
                    label: '分享數',
                },
            ],
            typeList: [
                {
                    value: '',
                    label: '全部',
                },
                {
                    value: 'VIDEO',
                    label: '影片',
                },
                {
                    value: 'IMAGE',
                    label: '圖片',
                },
                {
                    value: 'ARTICLE',
                    label: '文章',
                },
                {
                    value: 'HTML',
                    label: '互動網頁',
                },
            ],
            articleRes: [],
            breadList: [
                { id: 'hot', name: '所有排行' },
                { id: 'new', name: '所有排行' },
            ],
        };
    },
    created() {
        this.display = this.$store.state.displayArticles;
        const sort = this.$route.params.sort;
        const selects = this.$store.state.rankingSelects;
        if (sort) {
            this.count = sort === 'hot' ? this.countList[1] : this.countList[0];
        } else {
            this.count = selects.count || this.countList[0];
        }
        this.category = sort ? '' : selects.category || '';
        this.time = sort ? this.timeList[0] : selects.time || this.timeList[0];
        this.type = sort ? this.typeList[0] : selects.type || this.typeList[0];

        this.currentPage = Number(this.$route.params.page);
        this.getList(this.currentPage);
        this.setRankingSelects();
    },
    computed: {
        gaData() {
            return this.systemName + '|' + this.contentPage + '|';
        },
    },
    methods: {
        getList(page) {
            this.loading = true;
            page = Number(page);
            if (page < 1 || !page || page > 3) {
                this.routerTo(1);
                return;
            }
            this.lastPage = 0;
            this.total = 0;
            this.articleRes = [];
            let startTime = null;
            const today = moment().format('YYYY-MM-DD');
            switch (this.time.value) {
                case 'w':
                    startTime = moment().subtract(7, 'days').format('YYYY-MM-DD');
                    break;
                case 'm':
                    startTime = moment().subtract(1, 'months').format('YYYY-MM-DD');
                    break;
                case 'y':
                    startTime = moment().subtract(1, 'years').format('YYYY-MM-DD');
                    break;
                default:
                    startTime = '2000-01-01';
            }
            const data = {
                conditions: [
                    { column: 'firstContentCategory', value: this.category, operator: 'eq' },
                    { column: 'contentType', value: this.type.value, operator: 'eq' }],
                checkStartDate: startTime,
                checkEndDate: today,
                sortBy: [this.count.value],
                sortDesc: [true],
                size: page === 3 ? 6 : 12,
                page: page - 1,
            };
            post('/api/content/list/search', data)
                .then((res) => {
                    if (res.status === 200) {
                        const result = res.response;
                        this.currentPage = page;
                        if (result.contents.length > 0) {
                            this.articleRes = result.contents;
                            this.total = result.total > 30 ? 30 : result.total;
                            this.lastPage = Math.ceil(this.total / 12);
                        }
                    } else {
                        this.go404Page(res.status);
                    }
                })
                .catch((error) => {
                    this.go404Page(error.status);
                }).finally(() => {
                    this.loading = false;
                });
        },
        setRankingSelects() {
            const data = {
                category: this.category,
                time: Object.assign(this.time),
                type: Object.assign(this.type),
                count: Object.assign(this.count),
            };
            this.$store.dispatch('setRankingSelects', data);
        },
        setTime(value) {
            if (this.time.value !== value.value) {
                this.time = Object.assign(value);
                this.setRankingSelects();
                this.routerTo(1);
            }
        },
        setType(value) {
            if (this.type.value !== value.value) {
                this.type = Object.assign(value);
                this.setRankingSelects();
                this.routerTo(1);
            }
        },
        setCount(value) {
            if (this.count.value !== value.value) {
                this.count = Object.assign(value);
                this.setRankingSelects();
                this.routerTo(1);
            }
        },
        setDisplay(type) {
            this.setDisplayArticles(type);
        },
        getPage(value) {
            this.currentPage = value;
            this.routerTo(value);
        },
        getCategory(val) {
            this.category = val;
            this.setRankingSelects();
            this.routerTo(1);
        },
        routerTo(pg) {
            this.$router.push({ name: 'ranking', params: { page: pg } }).catch(() => { });
            this.getList(pg);
        },
    },
};
</script>
<style lang="scss" scoped>
.itemList {
    .lightcolor {
        color: #d5d5d5;
    }
}
.listType {
    position: absolute;
    top: -3.5rem;
    right: 0;
    @include media-breakpoint-up(md) {
        top: -3rem;
    }
    @include media-breakpoint-up(lg) {
        margin-top: 0;
        top: 0;
        position: relative;
    }
}
</style>
